import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpDeleteReferringSpecialist} from '../http/referring-specialists.http'
import {QUERY_KEYS} from '@/queryClient'

export const useDeleteReferringSpecialist = (
    options?: Omit<UseMutationOptions<unknown, unknown, string>, 'mutationFn'>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: referringSpecialistId => httpDeleteReferringSpecialist({urlParams: {referringSpecialistId}}),
        ...options,
        onSuccess: async (data, error, variables) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REFERRING_SPECIALISTS]})
            options?.onSuccess?.(data, error, variables)
        }
    })
}
